<template>
  <div>
    <div class="returnInfo">
      <div class="title">
        <h3>回访信息</h3>
      </div>
      <div class="listContent">
        <Timeline>
          <TimelineItem
            :color="item.type == '回访记录' ? 'blue' : 'green'"
            v-for="item in visitList"
            :key="item.id"
          >
            <p class="time">{{ item.create_time }}</p>
            <p class="content" v-if="item.type == '回访记录'">
              回访记录：{{ item.group }}
              {{ item.come_way }}
              {{ item.return_name }}
              <span style="color: blue">{{ item.content }}</span>
              下次回访时间：{{ item.visit_time }} {{ item.store }}
              {{ item.department }} {{ item.user }}
            </p>
            <p class="content" v-else>
              系统记录：{{ item.operate_log }}
              <span style="color: blue">{{ item.content }}</span>
              {{ item.store }} {{ item.department }} {{ item.user }}
            </p>
          </TimelineItem>
        </Timeline>
        <!-- <div class="noMore">没有更多了</div> -->
        <Divider>没有更多了</Divider>
      </div>
    </div>
    <div class="addReturnInfo">
      <div class="title">
        <h3>添加回访</h3>
        <Button type="primary" @click="handleSubmit('formValidate')"
          >确认</Button
        >
      </div>
      <div class="listContent">
        <Form
          ref="formValidate"
          :model="formItem"
          :rules="ruleValidate"
          :label-width="80"
        >
          <Row>
            <Col :span="12">
              <FormItem label="客户分组" prop="group_id">
                <Select v-model="formItem.group_id" placeholder="请选择">
                  <Option
                    v-for="item in customerGroudList"
                    :key="item.id"
                    :value="item.id + ''"
                    >{{ item.name }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col :span="12">
              <FormItem label="预产期" prop="child_birth">
                <DatePicker
                  type="date"
                  placeholder="请选择"
                  style="display: block"
                  @on-change="ChildBirthChange"
                  :editable="false"
                  :clearable="false"
                  v-model="formItem.child_birth"
                ></DatePicker>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col :span="8">
              <FormItem label="跟进结果" prop="come_status">
                <Select v-model="formItem.come_status" placeholder="请选择">
                  <Option value="1">待确定</Option>
                  <Option value="3">有需求</Option>
                  <Option value="2">已到店</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="8" v-if="formItem.come_status == '2'">
              <FormItem label="到店时间" class="mb-10" prop="come_date">
                <DatePicker
                  v-model="formItem.come_date"
                  format="yyyy-MM-dd"
                  placeholder="请选择"
                  style="display: block"
                ></DatePicker>
              </FormItem>
            </Col>
            <Col :span="8" v-if="formItem.come_status == '2'">
              <FormItem label="到店方式" prop="come_id">
                <Select v-model="formItem.come_id" placeholder="请选择">
                  <Option
                    v-for="item in returnSettingList"
                    :value="item.id + ''"
                    :key="item.id"
                    >{{ item.return_info }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row v-if="formItem.come_status == '2'">
            <Col :span="24">
              <FormItem label="到店结果" prop="arrival_result_id">
                <RadioGroup v-model="formItem.arrival_result_id">
                  <Radio
                    :label="item['id'].toString()"
                    v-for="item in arrival_result"
                    :key="item['id'].toString()"
                    >{{ item["result"] }}</Radio
                  >
                </RadioGroup>

                <Input
                  v-if="
                    formItem.come_status == '2' &&
                    formItem.arrival_result_id == '0'
                  "
                  v-model="formItem.other"
                  :maxlength="20"
                  placeholder="1-12个字符"
                ></Input>
              </FormItem>
            </Col>
          </Row>
             
          <Row>
            <Col :span="12">
              <FormItem label="回访方式" prop="return_id">
                <Select v-model="formItem.return_id" placeholder="请选择">
                  <Option
                    v-for="item in returnMode"
                    :value="item.id + ''"
                    :key="item.id"
                    >{{ item.return_info }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col :span="12">
              <FormItem
                label="下次回访日期"
                prop="visit_time"
                :label-width="100"
              >
                <DatePicker
                  type="date"
                  placeholder="请选择"
                  :options="visit_time_option"
                  style="display: block"
                  :transfer="true"
                  v-model="formItem.visit_time"
                ></DatePicker>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <!-- <Col :span="24">
                            <FormItem label="分娩医院" prop="hospital">
                                <Input v-model="formItem.hospital" placeholder="请输入"></Input>
                            </FormItem>
                        </Col> -->
                          <Col :span="12">
              <FormItem label="客户预算" prop="budget">
                <Input
                  v-model="formItem.budget"
                  :maxlength="20"
                  placeholder="客户预算（元）"
                ></Input>
              </FormItem>
            </Col>
            <Col :span="12">
              <FormItem label="分娩医院" prop="hospital">
                <Select
                  v-model="formItem.hospital"
                  filterable
                  remote
                  transfer
                  clearable
                  @on-query-change="remoteMethod"
                  :remote-method="remoteMethod1"
                  :loading="remoteLoading"
                >
                  <Option
                    v-for="(option, index) in hospitalList"
                    :key="index"
                    :value="option.label"
                    :label="option.label"
                  >
                    <span>{{ option.label }}</span>
                    <span style="float: right; color: #ccc">{{
                      option.value
                    }}</span>
                  </Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col :span="24">
              <FormItem label="回访记录" prop="content">
                <Input
                  v-model="formItem.content"
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 5 }"
                  :maxlength="500"
                  placeholder="请在15-500字内描述回访内容"
                ></Input>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "returnInfo",
  props: [
    "customerInfoDetailId",
    "customerGroudList",
    "uploadReturn",
    "customerDrawer",
  ],
  data() {
    let that = this;
    return {
      visit_time_option: {
        disabledDate(date) {
          let day = 89;
          if (that.formItem.child_birth) {
            day = 13;
          }
          return (
            date &&
            (date.valueOf() < Date.now() - 86400000 ||
              date.valueOf() > Date.now() + 86400000 * day)
          );
        },
      },
      remoteLoading: false,
      hospitalList: [],
      arrival_result: [],
      formItem: {
        // member_id:'',
        group_id: "",
        child_birth: "",
        come_status: "",
        come_id: "",
        return_id: "",
        visit_time: "",
        hospital: "",
        content: "",
        come_date: [],
        arrival_result_id: "",
        other: "",
      },
      ruleValidate: {
        group_id: [{ required: true, message: "请选择", trigger: "change" }],
        come_status: [{ required: true, message: "请选择", trigger: "change" }],
        come_id: [{ required: true, message: "请选择", trigger: "change" }],
        return_id: [{ required: true, message: "请选择", trigger: "change" }],
        come_date: [
          {
            required: true,
            message: "请选择",
            type: "date",
            validator: (rule, value, callback) => {
              if (this.formItem.come_date === "") {
                return callback(new Error("请选择到店日期 "));
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
        arrival_result_id: [{ required: true, message: "请选择到店结果", trigger: "change" }],
        visit_time: [
          {
            required: true,
            type: "date",
            message: "请选择",
            trigger: "change",
          },
        ],
        content: [
          { required: true, message: "请输入", trigger: "blur" },
          {
            type: "string",
            min: 15,
            max: 500,
            message: "请在15-500字内描述回访内容",
            trigger: "blur",
          },
        ],
      },
      returnSettingList: [],
      returnMode: [],
      visitList: [],
    };
  },
  methods: {
    apiArrivalResultList() {
      serve.fetchGet(api.arrivalResultList).then((data) => {
        this.arrival_result = data["list"];
        this.arrival_result.push({
          id: 0,
          result: "其它结果",
        });
        console.log("this.arrival_result ", this.arrival_result);
      });
    },
    //获取医院
    apiGetHospital(address) {
      serve
        .fetchGet(api.crmChildbirthHospital, { address: address })
        .then((data) => {
          // console.log(data)
          let arr = [{ value: address, label: address }];
          data.result.map((item) => {
            arr.push({
              value: item.address_region,
              label: item.address_name,
            });
          });
          this.hospitalList = arr;
          // console.log('this.hospitalList',this.hospitalList)
          // console.log(' this.remoteLoading', this.remoteLoading)
          setTimeout(() => {
            this.remoteLoading = false;
          }, 200);
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    remoteMethod1(query) {},
    //医院检索
    remoteMethod(query) {
      // console.log('query remoteMethod',query)
      // console.log('hospitalList',this.hospitalList)
      this.remoteLoading = true;
      if (query !== "") {
        this.apiGetHospital(query);
      } else {
        this.hospitalList = [];
        this.remoteLoading = false;
      }
    },
    //请求添加回访
    apiAddVisit() {
      this.formItem.come_date = util.dateFormat(this.formItem.come_date);
      let params = {
        member_id: this.customerInfoDetailId,
        group_id: this.formItem.group_id,
        come_id: this.formItem.come_id,
        come_date: this.formItem.come_date,
        return_id: this.formItem.return_id,
        visit_time: util.dateFormat(this.formItem.visit_time),
        hospital: this.formItem.hospital,
        content: this.formItem.content,
        budget:this.formItem.budget,
        come_status: this.formItem.come_status,
        arrival_result_id : this.formItem.arrival_result_id,
        other : (this.formItem.arrival_result_id == '0'?this.formItem.other:'')
      };
      console.log("this.formItem.come_date", this.formItem.come_date);
      if (this.formItem.child_birth != "") {
        params.child_birth = util.dateFormat(this.formItem.child_birth);
      }
      if (this.formItem.hospital != "") {
        params.hospital = this.formItem.hospital;
      }
      serve
        .fetchPost(api.addVisit, params)
        .then((data) => {
          // console.log(data)
          this.$Message.success("添加成功");
          this.$emit("watchUpdate", true, this.customerInfoDetailId);
          this.$refs.formValidate.resetFields();
          this.getVisits();
          this.getReturnInfoDetail();
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    // 添加回访确认
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.apiAddVisit();
        } else {
          this.$Message.error("请完善表单");
        }
      });
    },
    //回访记录
    getVisits() {
      let params = {
        member_id: this.customerInfoDetailId,
        type: "my", //all-连锁客户(所有客户) store-客户管理(客户管理) my-我的客户(我的客户)
      };
      serve
        .fetchGet(api.myMemberGetMemberVisits, params)
        .then((data) => {
          // console.log(data)
          this.visitList = data.data;
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    //到店方式
    getReturnSettingList() {
      serve
        .fetchGet(api.myMemberShopWay, {})
        .then((data) => {
          // console.log(data)
          this.returnSettingList = data.return_settings;
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    //回访方式
    getReturnMode() {
      serve
        .fetchGet(api.myMemberReturnWay, {})
        .then((data) => {
          // console.log('回访方式',data)
          this.returnMode = data.return_settings;
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    //添加回访时输入框用户信息回显
    getReturnInfoDetail() {
      let params = {
        member_id: this.customerInfoDetailId,
      };
      serve
        .fetchGet(api.getMemberInfo, params)
        .then((data) => {
          // console.log('添加回访时输入框用户信息回显',data)
          let come_id = "";
          if (data.is_come) {
            for (let item of this.returnSettingList) {
              if (item.return_info == data.come_type)
                come_id = item.id.toString();
            }
          }
          this.formItem.hospital = data.hospital;
          this.formItem.child_birth = data.child_birth;
          this.formItem.status = data.is_come == true ? "2" : "1";
          this.formItem.group_id = data.member_group_id + "";
          this.formItem.come_id = come_id;
          this.formItem.come_date = data.come_date;
          this.formItem.budget  = data.budget;
        })
        .catch((error) => {
          this.$Message.error(error.response.data.message);
        });
    },
    ChildBirthChange(date) {
      if (this.formItem.visit_time !== "") {
        if (Date.now() + 86400000 * 13 < this.formItem.visit_time.valueOf()) {
          this.$Message.warning("请重新选择下次回访日期!");
          // let date = new Date(Date.now() + 86400000*6);
          //
          // let Y = date.getFullYear() + '-';
          // let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
          // let D = date.getDate() + ' ';
          // this.formItem.visit_time = Y+M+D
          this.formItem.visit_time = "";
        }
      }
    },
  },
  watch: {
    customerInfoDetailId() {
      this.$refs.formValidate.resetFields();
      this.getReturnSettingList();
      this.getReturnMode();
      this.getVisits();
      this.getReturnInfoDetail();
      this.apiArrivalResultList();
    },
    uploadReturn(val) {
      // console.log(val)
      this.getVisits();
      this.apiArrivalResultList();

      this.$emit("watchUpdate", true, this.customerInfoDetailId, false);
    },
    customerDrawer() {
      this.apiArrivalResultList();
      this.getVisits();
    },
  },
};
</script>
<style scoped>
.returnInfo .listContent {
  height: calc(42vh - 43px);
  overflow: auto;
  border-bottom: 1px solid #eee;
}
.addReturnInfo {
  margin-top: 10px;
}
.addReturnInfo .listContent {
  height: calc(42vh - 44px);
  overflow: auto;
}
.time {
  font-size: 14px;
  font-weight: bold;
}
.content {
  padding-left: 5px;
  font-size: 14px;
}
.title {
  padding-top: 10px;
  height: 32px;
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.noMore {
  text-align: center;
  color: #999;
}
</style>



// WEBPACK FOOTER //
// src/commonTmp/CRM/CRM_returnInfo.vue